import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { useContent } from "./ContentContext";
import { useTx, txtStyle } from "./siteText";

const COLORS = ["#0047AB", "#E76F51", "#00B4D8", "#6B3FA0", "#D62F72"];

export const Testimonials = () => {
  const { settings } = useContent();
  const tx = useTx();
  const list = settings.testimonials || [];
  return (
    <section className="relative py-24 md:py-32 bg-cantina-alt" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal className="text-center flex flex-col items-center mb-16">
          <p className="font-script text-cantina-terracotta mb-2" style={txtStyle(tx("testimonials.eyebrow"))}>{tx("testimonials.eyebrow").text}</p>
          <h2 className="font-display tracking-tight text-cantina-ink" style={txtStyle(tx("testimonials.heading"))}>{tx("testimonials.heading").text}</h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {list.map((t, i) => {
            const color = t.color || COLORS[i % COLORS.length];
            return (
              <Reveal key={i} delay={i * 0.12}>
                <figure className="dish-card h-full bg-cantina-surface rounded-3xl p-8 md:p-9 border border-cantina-line shadow-[0_10px_30px_rgba(23,35,59,0.05)] border-t-4" style={{ borderTopColor: color }} data-testid={`testimonial-${i}`}>
                  <Quote size={30} style={{ color }} className="mb-5" />
                  <blockquote className="font-display italic leading-relaxed text-cantina-ink mb-6" style={txtStyle(tx("testimonials.quote"))}>“{t.quote}”</blockquote>
                  <figcaption className="font-sans tracking-[0.2em] uppercase text-cantina-ink/50" style={txtStyle(tx("testimonials.author"))}>— {t.by}</figcaption>
                </figure>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
